import { styled } from 'styled-components';
import ImageWrapper from '../../../new-components/ImageWrapper';
import bannerImg from '../../../public/assets/images/nawy-now/egypt-map-banner.png';
import bannerImgAr from '../../../public/assets/images/nawy-now/egypt-map-banner-ar.png';
import { useRouter } from 'next/router';

interface ExploreNawyNowMapProps {
  handleClick?: () => void;
}

const ExploreNawyNowMap = ({ handleClick }: ExploreNawyNowMapProps) => {
  const { locale } = useRouter();
  return (
    <Container className="explore-nawy-now-container" onClick={handleClick}>
      <ImageWrapper
        src={locale == 'ar' ? bannerImgAr : bannerImg}
        fill
        alt="nawy-now-sahel-bg"
        className="explore-nawy-now-bg"
        objectFit="cover"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 140px;
  position: relative;
  margin: 24px 0px;
  border-radius: 16px;
  overflow: hidden;
`;

export default ExploreNawyNowMap;
